import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

// Styles
const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 12,
    fontFamily: "Helvetica",
    lineHeight: 1.5,
  },
  title: {
    fontSize: 24,
    marginBottom: 20,
    color: "#4F46E5", // Indigo-600
    fontWeight: "bold",
  },
  section: {
    marginBottom: 20,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    borderBottom: "1px solid #eee",
    paddingVertical: 6,
  },
  headerRow: {
    backgroundColor: "#F3F4F6", // Gray-100
    fontWeight: "bold",
  },
  totalRow: {
    fontWeight: "bold",
    fontSize: 14,
    marginTop: 10,
  },
});

// PDF Content
const InvoiceDocument = ({ data }) => {
  const {
    client,
    service,
    rate,
    hours,
    tax,
    subtotal,
    taxAmount,
    total,
  } = data;

  return (
    <Document>
      <Page size="A4" style={styles.page}>
        {/* Invoice Title */}
        <Text style={styles.title}>Smart Invoicer</Text>

        {/* Client Info */}
        <View style={styles.section}>
          <Text>Invoice To: {client}</Text>
          <Text>Date: {new Date().toLocaleDateString()}</Text>
        </View>

        {/* Table Header */}
        <View style={[styles.row, styles.headerRow]}>
          <Text>Service</Text>
          <Text>Rate</Text>
          <Text>Hours</Text>
          <Text>Subtotal</Text>
        </View>

        {/* Table Row */}
        <View style={styles.row}>
          <Text>{service}</Text>
          <Text>${rate}/hr</Text>
          <Text>{hours}</Text>
          <Text>${subtotal.toFixed(2)}</Text>
        </View>

        {/* Tax + Total */}
        <View style={styles.section}>
          <Text>Tax ({tax}%): ${taxAmount.toFixed(2)}</Text>
          <Text style={styles.totalRow}>Total: ${total.toFixed(2)}</Text>
        </View>

        {/* Footer */}
        <View style={styles.section}>
          <Text>Thank you for your business!</Text>
          <Text>Generated by Smart Invoicer AI</Text>
          <Text>Design and Developed by Syed Haris</Text>
        </View>
      </Page>
    </Document>
  );
};

// PDF Download Link Component
export const InvoiceDownloadLink = ({ data }) => {
  if (!data) return null;

  return (
    <PDFDownloadLink
      document={<InvoiceDocument data={data} />}
      fileName={`invoice-${data.client}.pdf`}
      className="mt-4 inline-block bg-indigo-600 text-white px-4 py-2 rounded hover:bg-indigo-700"
    >
      {({ loading }) => (loading ? "Generating PDF..." : "Download Invoice PDF")}
    </PDFDownloadLink>
  );
};
